import { Navigate } from "react-router";
import { EmptyState, ErrorBanner, Loading } from "@/components/ui/feedback";
import { useWorkspaces } from "../api/session";
import { NewWorkspaceForm } from "../features/settings/WorkspaceSettingsPage";
import { lastWorkspace } from "../layout/workspace-context";

/** `/` → último workspace usado (se ainda for do usuário) ou o primeiro. */
export function RootRedirect() {
  const workspaces = useWorkspaces();
  if (workspaces.isPending) return <Loading />;
  if (workspaces.isError) return <ErrorBanner error={workspaces.error} />;
  const last = lastWorkspace();
  const target = workspaces.data.find((w) => w.id === last) ?? workspaces.data[0];
  if (!target)
    return (
      <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-4 p-4">
        <EmptyState title="Você ainda não participa de nenhum workspace.">
          Crie um agora ou peça um convite a quem já usa.
        </EmptyState>
        <NewWorkspaceForm />
      </main>
    );
  return <Navigate to={`/w/${target.id}`} replace />;
}
